/**
 * Build URL to a dev-port app from the user's browser.
 *
 * On partner.werking.tools we route through the wildcard subdomain proxy
 * (`<port>.partner.werking.tools`) so apps run unmodified on their port —
 * Next.js absolute asset paths (`/_next/...`) just work, no path rewrite,
 * no basePath. Auth is gated by nginx auth_request → /internal/auth-port.
 *
 * On dev (no wildcard cert) we point straight at the app's port on the same
 * host the CUI was reached on. Dev apps bind 0.0.0.0, so they're reachable on
 * that host — the app runs on its own origin, Next.js absolute paths and
 * client-side navigation just work, no path rewrite, no basePath. This
 * deliberately bypasses the CUI auth layer; the dev server is network-gated
 * and each app carries its own login.
 */
export function devPortUrl(port: number, path: string = '/'): string {
  if (typeof window === 'undefined') return `/app-proxy/${port}${path}`;
  const host = window.location.hostname;
  if (host === 'partner.werking.tools' || host.endsWith('.partner.werking.tools')) {
    return `https://${port}.partner.werking.tools${path}`;
  }
  return `${window.location.protocol}//${host}:${port}${path}`;
}
